import { useAuth0 } from '@auth0/auth0-react'
import { removeLocalStorageItem } from 'app/api/localStorage'
import { MetricEventType } from 'features/metrics/api/metrics'
import { sendMetricEvent } from 'features/metrics/model/metricsMutations'
import { useCallback } from 'react'
import settings from 'settings'

function useAuthenticationLogout() {
  const { logout: auth0Logout } = useAuth0()

  const logout = useCallback(async () => {
    removeLocalStorageItem(settings.loginAsStudentKey)
    removeLocalStorageItem(settings.localStorageOrgIdKey)
    sendMetricEvent(MetricEventType.UserLogout)
    auth0Logout({ logoutParams: { returnTo: `${settings.accountsUrl}/logout` } })
  }, [auth0Logout])

  return { logout }
}

export default useAuthenticationLogout
